import { render, staticRenderFns } from "./PaginationWithReorder.vue?vue&type=template&id=614ca59a&scoped=true&"
import script from "./PaginationWithReorder.vue?vue&type=script&lang=js&"
export * from "./PaginationWithReorder.vue?vue&type=script&lang=js&"
import style1 from "./PaginationWithReorder.vue?vue&type=style&index=1&id=614ca59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614ca59a",
  null
  
)

export default component.exports